import styles from './style.module.css';
import Modal from 'react-responsive-modal';

interface IModalHasFailed {
  modalIsOpen: boolean;
  toggleModal: () => void;
  tryAgain: () => void;
  cancelAnswer: () => void;
  accuracyPercentage?: number;
  minimumScore?: number;
}

export function ModalHasFailed({
  modalIsOpen,
  toggleModal,
  tryAgain,
  cancelAnswer,
  accuracyPercentage,
  minimumScore,
}: IModalHasFailed) {
  return (
    <Modal
      open={modalIsOpen}
      onClose={() => {
        toggleModal();
      }}
      center
    >
      <div className={`${styles.modalBanner} ${styles.modalBannerDanger}`}>
        <i className="material-icons-outlined">sentiment_dissatisfied</i>
      </div>
      <div className={styles.contents}>
        <h2 className={styles.title}>
          <span className={styles.highlightText}>OPS!</span> Quase lá...
        </h2>
        <p className={styles.detail}>
          Você acertou{' '}
          <span className={styles.highlightText}>{accuracyPercentage}%</span>{' '}
          das questões
          {typeof minimumScore === 'number' ? (
            <>
              , mas o mínimo necessário é <strong>{minimumScore}%</strong>.
            </>
          ) : (
            '.'
          )}
        </p>
        <p className={styles.caption}>
          Não desanime! Revise o conteúdo e tente novamente.
        </p>
      </div>
      <div className={styles.contentBtn}>
        <button
          onClick={() => {
            toggleModal();
            tryAgain();
          }}
          className={styles.btnAgree}
          type="button"
        >
          Responder de novo
        </button>
        <button
          onClick={() => {
            toggleModal();
            cancelAnswer();
          }}
          className={styles.btnBack}
          type="button"
        >
          Responder depois
        </button>
      </div>
    </Modal>
  );
}
